<div class="modal-header">
  <h3>{{ ExemptVendor?.id ? 'Edit' : 'Add' }} ExemptVendor</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close('cross close')"
  ></button>
</div>
<div class="modal-body">
  @if (ExemptVendorForm) {
    <form [formGroup]="ExemptVendorForm">
      <div class="row g-3 align-items-center">
        <div class="col-4">
          <label class="form-label" requiredAsterisk>Exempt Vendor Type</label>
          <select class="form-select" formControlName="ExemptVendorTypeId">
            <option [ngValue]="null" selected disabled>Pick one...</option>
            @for (type of ExemptVendorTypes; track type) {
              <option [ngValue]="type.id">
                {{ type.type }}
              </option>
            }
          </select>
        </div>
        <div class="col-4">
          <label class="form-label" requiredAsterisk>Vendor Legal Name</label>
          <input type="text" class="form-control" formControlName="legalName" />
        </div>
        <div class="col-4">
          <label class="form-label">Vendor DBA</label>
          <input type="text" class="form-control" formControlName="dba" />
        </div>
        <div class="col-4">
          <label class="form-label">Country</label>
          <select class="form-select" formControlName="country">
            <option [ngValue]="null" selected disabled>Pick one...</option>
            @for (country of countries | keyvalue; track country) {
              <option [ngValue]="country.value">
                {{ country.key }}
              </option>
            }
          </select>
        </div>
        <div class="col-4">
          <label class="form-label">Tax Structure</label>
          <select class="form-select" formControlName="taxStructure">
            <option [ngValue]="null" selected disabled>Pick one...</option>
            @if (ExemptVendorForm.controls.country.value === 'US') {
              @for (option of usTaxStructures; track option) {
                <option [ngValue]="option">
                  {{ option }}
                </option>
              }
            }
            @if (ExemptVendorForm.controls.country.value === 'CA') {
              @for (option of caTaxStructures; track option) {
                <option [ngValue]="option">
                  {{ option }}
                </option>
              }
            }
          </select>
        </div>
        @if (
          ExemptVendorForm.get('taxStructure')?.value ===
          'Limited Liability Company (LLC)'
        ) {
          <div class="col-4">
            <label class="form-label" requiredAsterisk>LLC Type</label>
            <select class="form-select" formControlName="llcType">
              <option [ngValue]="null" selected disabled>Pick one...</option>
              @for (type of llcTypes; track type) {
                <option [ngValue]="type.value">
                  {{ type.label }}
                </option>
              }
            </select>
          </div>
        }
        <div class="col-4">
          <label class="form-label">EIN</label>
          <input
            type="text"
            class="form-control"
            placeholder="__-_______"
            [inputMask]="einMask"
            formControlName="ein"
          />
        </div>
        <div class="col-4">
          <label class="form-label">SSN</label>
          <input
            type="text"
            class="form-control"
            placeholder="___-__-____"
            [inputMask]="ssnMask"
            formControlName="ssn"
          />
        </div>
        <div class="col-4">
          <label class="form-label">Office Phone</label>
          <input
            type="tel"
            class="form-control"
            placeholder="(___)___-____"
            [inputMask]="phoneMask"
            formControlName="phone"
          />
        </div>
        <div class="col-4">
          <label class="form-label">Website</label>
          <input type="text" class="form-control" formControlName="website" />
        </div>
      </div>
      <div class="row">
        <h3>Street Address</h3>
        <hr class="mb-0" />
        <div class="col">
          <app-address-form
            [addressForm]="ExemptVendorForm.controls.StreetAddress"
            [isStreet]="true"
            [country]="ExemptVendorForm.controls.country.value"
          ></app-address-form>
        </div>
      </div>
      <div class="row">
        <h3>Mailing Address</h3>
        <hr class="mb-0" />
        <div class="col">
          <app-address-form
            [addressForm]="ExemptVendorForm.controls.MailingAddress"
            [isMailing]="true"
            [country]="ExemptVendorForm.controls.country.value"
          ></app-address-form>
        </div>
      </div>
      @if (ExemptVendorForm.controls.Contacts.value.length > 0) {
        <form
          [formGroup]="ExemptVendorForm.controls.Contacts.controls[0]"
          class="row"
        >
          <h3>Contact</h3>
          <hr class="mb-0" />
          <div class="col-6">
            <label for="firstName" class="form-label">First Name</label>
            <input
              type="text"
              class="form-control"
              id="firstName"
              formControlName="firstName"
            />
          </div>
          <div class="col-6">
            <label for="lastName" class="form-label">Last Name</label>
            <input
              type="text"
              class="form-control"
              id="lastName"
              formControlName="lastName"
            />
          </div>
          <div class="col-12">
            <label for="email" class="form-label">Email</label>
            <input
              type="email"
              class="form-control"
              id="email"
              formControlName="email"
            />
          </div>
          <div class="col-12">
            <label for="phone1" class="form-label">Phone</label>
            <input
              type="tel"
              class="form-control"
              id="phone1"
              placeholder="(___)___-____"
              [inputMask]="phoneMask"
              formControlName="phone1"
            />
          </div>
        </form>
      }
    </form>
  }
</div>
<div class="modal-footer">
  <div class="col-2">
    <button type="button" class="btn btn-danger h-100" (click)="close()">
      Close
    </button>
  </div>

  <div class="col-2">
    <button type="button" class="btn btn-primary h-100" (click)="save()">
      Save
    </button>
  </div>
</div>
